import { anyApi } from "convex/server";
import type { api as generatedApi } from "../../../backend/convex/_generated/api";

// Keep the backend-generated API for types only, but use a browser-safe runtime
// function reference object so web-only builds do not bundle backend modules.
export const api = anyApi as unknown as typeof generatedApi;
